module.exports = __webpack_public_path__ + "static/media/view1.6e7ab399.jpg";